<template>
  <div class="" style="width: 100%;">
    <v-container>
      <v-row>
        <v-col class='d-flex flex-row align-center'>
          <v-btn text class="mx-2" @click="()=>{this.$router.go(-1)}">
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
          <h1>New {{this.singular}}<span v-if="this.data.name">:</span> {{this.data.name}}</h1>
        </v-col>
        <v-col>
          <v-progress-circular
            indeterminate
            color="green"
            v-if="loader"
          ></v-progress-circular>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card outlined style="background-color: rgba(0,0,0,0);">
            <v-card-title v-if="data.customerId">
              {{data.customerName}}
            </v-card-title>
            <v-card-subtitle> {{data.customerPhone}}</v-card-subtitle>
            <v-card-text v-if="!data.customerId">
              <v-text-field
                label="Customer"
                outlined
                dense
                v-model="customerSearchField.name"
                :loading="customerSearchField.loading"
                @keydown="searchCustomers('name')"
              />
              <v-text-field
                label="Phone"
                outlined
                dense
                v-model="customerSearchField.phone"
                @keydown="searchCustomers('phone')"
              />       
            </v-card-text>
            <v-card-actions>
              <v-btn v-if="!data.customerId" @click="createCustomer" small color='info'>Create</v-btn>
              <v-btn small @click="clearCustomerSearches" color='info'>Clear</v-btn>
            </v-card-actions>
          </v-card> 
          <div v-if="customerResults.length>0" class="d-flex flex-column">
            <span @click="selectCustomer(result.id)" style="border: 1px solid grey; border-radius: 7px; padding: 10px; margin-bottom: 5px;" v-for="(result, index) of customerResults" :key="index">
              <span>{{ result.fullName }} | {{ result.phone }}</span>
            </span>
          </div>       
          <!-- <v-btn class="ml-1 mr-2" @click="showCreateCustomerDialog('create')" color="info" small fab><v-icon>mdi-plus</v-icon></v-btn> -->
          <v-text-field
              label="Due On"
              outlined
              v-model="data.email"
          />
        </v-col>
        <v-col cols="9">
          <span v-if="data.customerId">
            <h2>Items</h2>
            <v-text-field
                label="Search Assets"
                outlined
                dense
                :loading="assetSearchField.loading"
                v-model="assetSearchField.value"
                @keyup="searchAssets"
            />
            <div style="width: 100%;" class="d-flex flex-row flex-wrap">
              <div @click="selectAsset(result2.id)" class="d-flex flex-row" style="width: 15%; margin-bottom: 10px; margin-right: 3px; border: 1px solid grey; padding: 10px; border-radius: 7px;" v-for="(result2, index2) in assetResults" :key="index2">
                <b>{{ result2.styleNo }}</b>
              </div>
            </div>
            <v-card outlined v-if="data.selectedAsset">
              <v-card-text>
                <h3>Style no: {{ data.selectedAsset.styleNo }}</h3>
                <v-text-field
                  label="Color"
                  outlined
                  dense
                  v-model="data.selectedAsset.color"
                />
  
              </v-card-text>
              <v-card-actions>
                <v-btn @click="createItem" small color='info'>Create</v-btn>
                <v-btn small @click="clearAssetSearches" color='info'>Clear</v-btn>
              </v-card-actions>
            </v-card>
          </span>
          <!-- <div v-for="(item, index) in fakeItems" :key="index">
            <div class="d-flex flex-column" style="border: 1px solid grey; padding: 10px; border-radius: 10px;">
              <span>
                Status: {{ item.status }}
                {{index+1}}. {{ item.Asset.styleNo }} - {{ item.color }} 
              </span>
              <span>
                Supplier: {{ item.Asset.Supplier.name }}
              </span>
            </div>
          </div> -->
          <span></span>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-btn @click="create" :disabled="!this.data.name">Create</v-btn>
        </v-col>
      </v-row>
    </v-container>
    <dialog-snack ref="snackbar" :color="snackObj.color" :text="snackObj.text"/>
  </div>
</template>
<script>
  import axios from 'axios';
  import {mapGetters} from "vuex";
  export default {
    data () {
      return {
        loader: false,
        snackObj: {
          color: '',
          text: ''
        },
        max25chars: v => v.length <= 25 || 'Input too long!',
        data: {},
        customers: [],
        assets: [],
        customerResults: [],
        assetResults: [],
        customerSearchField: {
          loading: false,
          name: "",
          phone: "",
        },
        assetSearchField: {
          value: '',
          loading: false,
        },
        customersSearchIndex: [],
        assetsSearchIndex: [],
        singular: "Special Order",
        singularLower: "specialorder",
        plural: "SpecialOrders",
        pluralLower: "specialorders",
        fakeItems: [{itemId: 2, status: "Ordered",Asset: {id: 2, styleNo: "1232A", Supplier: {id: 24, name: "Varion Technologies"}}, color: "NAVY"}]
      }
    },
    async mounted(){
      try{
        let res;
        res = await axios.get(`${this.getEndpoint}/api/customers`)
        if(res.data.error) throw res.data.error;
        this.customers = res.data.data; 
        
        for(let i = 0; i < this.customers.length; i++){
          let obj = {}
          obj.name = (this.customers[i].fullName).trim().replace(" ", '').toUpperCase()
          obj.phone = (this.customers[i].phone)?.trim().replace(" ", '').replace("-", '')
          this.customersSearchIndex.push(obj)
        }

        res = await axios.get(`${this.getEndpoint}/api/assets`)
        if(res.data.error) throw res.data.error;
        this.assets = res.data.data;

        for(let i = 0; i < this.assets.length; i++){
          let obj = {}
          obj.styleNo = (this.assets[i].styleNo).trim().replace(" ", '').toUpperCase()
          this.assetsSearchIndex.push(obj)
        }

      }
      catch (error) {
        console.error(error);
        this.snack(error.msg || error, "error");
      }
      finally {
        this.loader = false;
      }
    },
    computed: {
      ...mapGetters(['getEndpoint'])
    },
    methods: {
      snack(text, color=""){
        this.snackObj.text = text;
        this.snackObj.color = color;

        this.$refs.snackbar.openDialog();
      },
      selectCustomer(id){
        let c = this.customers.find(x=>x.id===id)
        this.data.customerId = c.id
        this.data.customerName = c.fullName
        this.data.customerPhone = c.phone
        this.$forceUpdate()
        this.customerResults = []
      },
      clearCustomer(){
        this.customerSearchField.value = ""
        this.data.customerId = null
        this.data.customerName = null
        this.data.customerPhone = null
        this.$forceUpdate()
      },
      async selectCustomerChanged(){
        try {
          //
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        }
      }, 
      clearCustomerSearches(){
        this.customerSearchField.name = ''
        this.customerSearchField.phone = ''
        this.clearCustomer()
      },
      searchCustomers(from){
        this.customerResults = []
        let searchTerm = ''
        if(from==="name"){
          searchTerm = this.customerSearchField.name.trim().replace(" ", '').replace("-", "").toUpperCase()
        }else if(from==="phone"){
          searchTerm = this.customerSearchField.phone.trim().replace(" ", '').replace("-", "").toUpperCase()
        }

        if(!searchTerm || searchTerm == ""){
          this.customerResults = []
          return
        }

        for(let i = 0; i < this.customersSearchIndex.length; i++){
          if(this.customersSearchIndex[i]?.name?.includes(searchTerm)||this.customersSearchIndex[i]?.phone?.includes(searchTerm)){
            this.customerResults.push(this.customers[i])
          }
        }

      },     
      async createCustomer(){
        try {
          let obj = {
            name: this.customerSearchField.name,
            phone: this.customerSearchField.phone,
          }
          let res = await axios.post(`${this.getEndpoint}/api/customers/fromSpecialOrder`, obj)
          if(res.data.id){
            this.snack(`${this.singular} Created 🎉`, "success");
          }
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        }
      },
      searchAssets(){
        this.assetResults = []
        let searchTerm = this.assetSearchField.value.trim().replace(" ", '').replace("-", "").toUpperCase()

        if(!searchTerm || searchTerm == ""){
          this.assetResults = []
          return
        }

        for(let i = 0; i < this.assetsSearchIndex.length; i++){
          if(this.assetsSearchIndex[i]?.styleNo?.includes(searchTerm)||this.assetsSearchIndex[i]?.styleNo?.includes(searchTerm)){
            this.assetResults.push(this.assets[i])
          }
        }
      },
      selectAsset(id){
        let a = this.assets.find(x=>x.id===id)
        this.data.selectedAsset = a
        this.$forceUpdate()
        this.assetResults = []
      }, 
      async create(){
        try {
          let res = await axios.post(`${this.getEndpoint}/api/${this.pluralLower}`, this.data)
          if(res.data.id){
            this.snack(`${this.singular} Created 🎉`, "success");
            setTimeout(()=>{
              this.$router.push({ path: `/${this.pluralLower}/view/${res.data.id}`})
            }, 3000)
          }
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        }
      },
      clearAssetSearches(){
        this.assetSearchField.value = ''
        this.clearAsset()
      },
      clearAsset(){
        this.assetSearchField.value = ""
        this.data.selectedAsset = null
        this.$forceUpdate()
      },
      async createItem(){
        try {
          let obj = {
            assetId: this.data.selectedAsset.id,
            colour: this.data.selectedAsset.color,
            customerId: this.data.customerId,
          }
          let res = await axios.post(`${this.getEndpoint}/api/items/`, obj)
          if(res.data.success){
            this.snack(`${this.singular} Created 🎉`, "success");
            this.clearAsset()
            
          }
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error, "error");
        }
      },
    }
  }
</script>
